/**
 * get image height based on width and viewport
 */
export const getSVGHeight = (width: string, viewPortWidth: number, viewPortHeight: number) => {
    const widthNum = Number(width.replace('px', ''));
    return`${ widthNum * viewPortHeight / viewPortWidth }px`;
};